import YoutubePartnerProgramSettings from './YoutubePartnerProgramSettings';

export default YoutubePartnerProgramSettings;
